import gql from 'graphql-tag'
import assign from 'lodash/assign'
import clone from 'lodash/clone'
import base from 'app/queries/base'

export default {

    all: function(options={}){

        return assign(clone(base), {

            query: gql`
                query AllActions($offset: Int, $limit: Int, $filter: ActionFilter, $sortField: ActionSortField, $sortDirection: SortDirection, $requireLocation: Boolean) {
                    viewer {
                        allActions(offset: $offset, limit: $limit, filter: $filter, sortField: $sortField, sortDirection: $sortDirection, requireLocation: $requireLocation) {
                            totalCount
                            items {
                                id
                                state
                                categories
                                categoriesField
                                measuringPoint
                                commentsOffice
                                commentsField
                                issueDate
                                alarmDeactivated
                                loggerId
                                projectId
                                deadline
                                locationTitle
                                locationLat
                                locationLng
                                logger {
                                    id
                                    serialNumber
                                    type {
                                        id
                                        title
                                    }
                                }
                                project {
                                    id
                                    title
                                    code
                                    locationTitle
                                    locationManual
                                    projectManager
                                }
                            }
                        }
                    }
                }`,

            variables(){

                return {
                    offset: null,
                    limit: null,
                    filter: {},
                    sortField: null,
                    sortDirection: null
                }
            },

            update: ({viewer}) => viewer.allActions

        }, options);
    },

    find: function(options={}){

        return assign(clone(base), {

            query: gql`
                query FindAction($actionId: ID!) {
                    viewer {
                        findAction(id: $actionId) {
                            id
                            state
                            categories
                            categoriesField
                            measuringPoint
                            commentsOffice
                            commentsField
                            issueDate
                            alarmDeactivated
                            measuringFrequency
                            transmissionFrequency
                            deadline
                            locationTitle
                            locationLat
                            locationLng
                            logger {
                                id
                                serialNumber
                                state
                                type {
                                    id
                                    title
                                }
                                activeAllocation {
                                    id
                                    endDate
                                }
                            }
                            project {
                                id
                                title
                                code
                                locationTitle
                                locationManual
                                projectManager
                                munisenseGroupId
                            }
                            user {
                                id
                                email
                                initials
                            }
                        }
                    }
                }`,

            update: ({viewer}) => viewer.findAction

        }, options);
    }
}